import React, {useState, useEffect} from "react";

function LectureCard({videoUrl, start, end, date, title, isClip, text}) {
    const [thumbnailUrl, setThumbnailUrl] = useState(null);

    useEffect(() => {
        const url = videoUrl + (start ? `#t=${start}` : "#t=20");
        setThumbnailUrl(url)
    }, [videoUrl, start, text]);


    console.log(thumbnailUrl);

    return (
        <a href={thumbnailUrl} target="_blank">
            <div className="rounded overflow-hidden shadow-md bg-zinc-50 ">
            <video className="w-full" preload="metadata" alt="Video thumbnail">
                {thumbnailUrl ? <source src={thumbnailUrl} type="video/mp4"/> : null}
            </video>

            <div className="px-6 py-4">
                {isClip && (
                    <div>
                        <p className="text-xs">{text.length > 250 ? text.substring(0, 250) + "..." : text}
                        <span className="text-xs bg-indigo-600 text-center text-slate-200 rounded-lg px-2 py-[1px] ml-2 w-min">{Math.floor(end - start)}s</span>
                        </p>
                    </div>
                )}
                <div className="font-medium text-lg">{title}</div>
                <p className="text-gray-700 text-sm">
                    <time>{date}</time>
                </p>
            </div>
            
            </div>
    </a>

    )
}

export default LectureCard;